<template>
  <div id="set_passwod">
    <!-- 设置密码 -->
    <el-dialog title="请设置余额支付密码" :visible.sync="setPass"
    @close="cancelSetPad"
     width="30%" class="set-pass pass"
     :append-to-body="true"
      id="orderlist">
      <div>
        <div class="steps">为了您的账号安全，请验证身份</div>
        <div class="phone">
          <span>手机号:</span>
          {{phoneNum}}
        </div>
        <el-form
          :model="setPassword"
          :rules="rules"
          ref="setPassword"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item prop="phoneCode">
            <el-input
              v-model="setPassword.phoneCode"
              type="number"
              placeholder="请输入验证码"
              maxlength="6"
            >
              <span
                v-if="getYzm"
                slot="suffix"
                class="get_yzm"
                @click="yzmTimeMinuse()"
              >{{yzmTtext}}</span>
              <span v-else slot="suffix">{{yzmTime}}S后重发</span>
            </el-input>
          </el-form-item>
          <el-form-item prop="payPassword">
            <el-input v-model="setPassword.payPassword" placeholder="请输入密码" type="password"></el-input>
          </el-form-item>
          <el-form-item prop="payPasswords">
            <el-input v-model="setPassword.payPasswords" placeholder="请再次输入密码确认" type="password"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelSetPad">取 消</el-button>
        <el-button type="primary" @click="passwordSet('setPassword')">确 定</el-button>
      </span>
    </el-dialog>
    <Geet :isGeet="isgt" @geetPath="onGeetestValCodePath" @clickChange="onGeetChange"></Geet>
  </div>
</template>

<script>
import Geet from "./Geet.vue";
import { geetestValCodeMixin } from "../../mixins/geetestValCodeMixin";
export default {
  mixins: [geetestValCodeMixin],
  props: {
    showPad: Boolean,
    phoneNum: String
  },
  data() {
    var checkCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入验证码"));
      } else if (value.length <= 5) {
        return callback(new Error("验证码小于6位"));
      }
      callback();
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.setPassword.payPasswords !== "") {
          this.$refs.setPassword.validateField("payPasswords");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.setPassword.payPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      // showPad: false,
      getYzm: true,
      yzmImg: false,
      yzmTime: 60,
      yzmTtext: "发送验证码",
      setPassword: {
        phoneCode: "",
        payPassword: "",
        payPasswords: ""
      },
      rules: {
        payPassword: [{ validator: validatePass, trigger: "blur" }],
        payPasswords: [{ validator: validatePass2, trigger: "blur" }],
        phoneCode: [{ validator: checkCode, trigger: "change" }]
      }
    };
  },
  computed: {
    setPass: {
      get() {
        return this.showPad
      },
      set(){
        this.cancelSetPad()
      }
    }
  },
  components: {
    Geet
  },
  methods: {
    onValCodeSent() {
      this.getYzm = false;
      this.yzmTime = 60;

      var auth_timetimer = setInterval(() => {
        this.yzmTime--;
        if (this.yzmTime <= 0) {
          this.getYzm = true;
          clearInterval(auth_timetimer);
          this.yzmTtext = "重新发送";
        }
      }, 1000);
      this.yzmImg = true;
      this.buttom = false;
    },
    // 关闭设置密码
    cancelSetPad(){
      this.$emit("showPasswod", false)
    },
    // 设置支付密码
    passwordSet(formName) {
      var _this = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$post(
            `/user/api/customer/modify_pay_pwd?code=${this.setPassword.phoneCode}&pwd=${this.setPassword.payPasswords}`
          ).then(res => {
            if (res.code == 0) {
              this.cancelSetPad()
              this.$store.state.hasPwd = true;
            } else {
              this.$message(res.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //验证码倒计时
    yzmTimeMinuse() {
      this.requestValCodeV2(this.$store.state.userPhone, "set_passwod");
      this.phoneFormat = true;
    }
  }
};
</script>

<style lang='scss' scoped>
#orderlist {
  &.set-pass {
    &/deep/.el-dialog__body{
      padding: 30px 20px !important;
    }
    .steps {
      color: #909399;
      font-size: 12px;
    }
    .phone {
      color: #2f3133;
      font-size: 14px;
      height: 14px;
      line-height: 1;
      margin-top: 30px;
      margin-bottom: 10px;
      span {
        color: #5e6066;
        margin-right: 6px;
      }
    }
    & /deep/ .get_yzm {
      background: transparent !important;
    }
    & /deep/ .el-form-item__content {
      margin-left: 0 !important;
    }
  }
}
</style>
